import { Breadcrumbs as MuiBreadcrumbs, breadcrumbsClasses, styled } from '@mui/material';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  overflow: 'hidden',
}));

export const Breadcrumbs = styled(MuiBreadcrumbs)(({ theme }) => ({
  color: theme.palette.primary[500],
  fontWeight: theme.typography.fontWeightMedium,
  outlineOffset: theme.spacing(1.5),

  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary[400]}`,
    '& [aria-selected="true"]': {
      outline: `2px solid ${theme.palette.primary[400]}`,
      outlineOffset: theme.spacing(0.5),
    },
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    flexWrap: 'nowrap',
  },
  [`& .${breadcrumbsClasses.li}`]: {
    whiteSpace: 'nowrap',
    '&:last-child': {
      display: 'none',
    },
  },
  [`& .${breadcrumbsClasses.separator}`]: {
    marginLeft: 1,
    marginRight: 1,
  },
}));
